module.exports = __webpack_public_path__ + "img/760f62b.png";